import { useContext } from 'react';
import Styles from './Toast.module.scss';
import classnames from "classnames"
import { AppContext } from '../../contexts/AppContext';
import { APP_KEY_IDS, DEVICE_TYPE } from '../../constants/constants';
import { useTransition, animated } from "react-spring";
import { isVisible } from '@testing-library/user-event/dist/utils';
import {ReactComponent as CloseIcon} from "../../icons/extra_icons/close_cross.svg"
import { useDispatch } from 'react-redux';
import { openWindow } from '../../actions';

interface ToastProps {
    id:string;
    index?:number;
    toast: any
    onClose: (id:string)=>void;
}

const Toast = ({ id,index=1, toast, onClose }: ToastProps) => {

    const { isMobile } = useContext(AppContext)
    const deviceType = isMobile ? DEVICE_TYPE.MOBILE : DEVICE_TYPE.DESKTOP
    const dispatch=useDispatch()

    const handleClick = () => {
        const newWindow = window.open(toast.visitLink, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const transition = useTransition(isVisible, {
        from: {
            x: "50%", scale: 0
        },
        enter: {
            x: "0%", scale: 1
        },
        leave: {
            x: "0%", scale: 0
        },
        to: {
            x: "50%", scale: 0
        }
    })

    return (
        <div className={classnames(Styles.container, Styles[deviceType])} onClick={toast.visitLink ? handleClick : () => { dispatch(openWindow(APP_KEY_IDS.AUTH))}} style={{animationDelay:`${index*0.5}s`}}>
            <div className={Styles.header}>
                <div className={Styles.icon} id={toast.appId} />
                <div className={Styles.app_name}>{toast.appName}</div>
                <div className={Styles.time}>{toast.time}</div>
            </div>
            {
                deviceType === DEVICE_TYPE.MOBILE && <div style={{ borderRadius: "50%" }} className={Styles.mobile_notification_icon}>
                    <div className={Styles.icon} id={DEVICE_TYPE.MOBILE ? toast.mobileAppId : toast.appId} />
                </div>
            }
            <div className={Styles.content}>
                <div className={Styles.title}>
                    {toast.title}
                </div>
                <div className={Styles.sub_text}>
                    {toast.subText}
                </div>
            </div>

            {
                deviceType === DEVICE_TYPE.MOBILE && toast.bannerImage && <div className={Styles.mobile_notification_icon}>
                    <img src={toast.bannerImage} />
                </div>
            }
            {
                deviceType === DEVICE_TYPE.DESKTOP && (
                    <div className={Styles.close_icon} onClick={()=>{onClose(id)}} >
                        <CloseIcon/>
                    </div>
                )            
            }
        </div>
    )
}

export default Toast
